export default __webpack_public_path__ + "static/media/bg-bubble-horizontal.0c7edd6a.png";